var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.content.length > 0)?_c('div',{staticClass:"tiptap-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),(_vm.content.length == 0)?_c('div',{staticClass:"tiptap-content",domProps:{"innerHTML":_vm._s(_vm.pageContent)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }